import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultCustomerDetailsGivenNameFormFieldDisplayText = {
    label: 'Given name',
    requiredMessage: 'Please enter your given name.',
    formatMessage: 'The given name you entered has an invalid format.',
    lengthMessage: 'Your given name must contain less than ${maxLength} characters.'
};
export const defaultCustomerDetailsFamilyNameFormFieldDisplayText = {
    label: 'Family name',
    requiredMessage: 'Please enter your family name.',
    formatMessage: 'The family name you entered has an invalid format.',
    lengthMessage: 'Your family name must contain less than ${maxLength} characters.'
};
export const defaultCustomerDetailsEmailFormFieldDisplayText = {
    label: 'Email address',
    requiredMessage: 'Please enter your email address.',
    formatMessage: 'The email address you entered has an invalid format.',
    lengthMessage: 'Your email address must contain less than ${maxLength} characters.'
};
export const defaultCustomerDetailsPhoneNumberFormFieldDisplayText = {
    label: 'Phone number',
    requiredMessage: 'Please enter your phone number.',
    formatMessage: 'The phone number you entered has an invalid format.',
    lengthMessage: 'Your phone number must contain less than ${maxLength} characters.'
};
export const customerDetailsFormFieldDisplayTextValidator = Validator.object({
    label: nonEmptyStringValidator,
    placeholder: Validator.optional(nonEmptyStringValidator),
    requiredMessage: nonEmptyStringValidator,
    formatMessage: nonEmptyStringValidator,
    lengthMessage: nonEmptyStringValidator
});
